<template>
  <div class="page__sidebar h-100">
    <component
      :is="sideBar"
      :counters="allCounters"
      :options="options"
      :selected-option="selectedOption"
      :store="store"
      :disable-add-filter="disableAddFilter"
      :view-all-enabled="viewAllEnabled"
      :custom-options="customOptions"
      :is-diagnosis="true"
      :view-all-allowed="viewAllAllowed"
      @expand="expand"
      @setDefaultOptionParent="setDefaultOption($event)"
      @contract="contract"
      @view-all-toggled="setViewAll($event)"
      @update-responsibilities="setResponsibilities($event)"
      @update:selected-option="changeSelectedOption"
      @click-add-filter="$emit('click-add-filter')"
      @remove-option="removeCustomOption"
      @update-option="showUpdateModal"
      @rename-option="showRenameModal"
    />
    <rename-custom-filter-modal
      id="renameCustomFilterModal"
      ref="renameModal"
      @ok="renameCustomOption"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import store from './DiagnosisSideBarStore'
import RenameCustomFilterModal from '@/components/customFilter/RenameCustomFilterModal'
import { CaseOperationGuardMixin } from '@/api/operations/mixins/guards/case-operation-guard.mixin'

export default {
    name: 'DiagnosisSideBar',
    components: {
        RenameCustomFilterModal
    },
    mixins: [
        CaseOperationGuardMixin
    ],
    props: {
        counters: { type: Object } // a map containing the numbers for each badge
    },
    data() {
        return {
            store: store,
            state: store.state
        }
    },
    computed: {
        sideBar() {
            return this.state.sideBar
        },
        customOptions() {
            return this.state.customOptions
        },
        options() {
            return this.state.options
        },
        selectedOption() {
            return this.state.selectedOption
        },
        disableAddFilter() {
            return this.gridRouteName !== this.$route.name
        },
        gridRouteName() {
            return this.state.gridRouteName
        },
        allCounters() {
            return this.counters
        },
        viewAllEnabled() {
            return this.state.config.viewAllEnabled
        },
        viewAllAllowed() {
            return this.$_canViewAllDiagnose()
        }
    },
    methods: {
        changeSelectedOption(value) {
            store.setSelectedOption(value)
            this.$router.push({ name: this.gridRouteName })
            this.$emit('changed-option', value)
        },
        selectDefaultOption() {
            store.selectDefaultOption()
            this.$emit('changed-option', this.state.selectedOption)
        },
        async removeCustomOption(option) {
            const modalConfirmationResponse = await this.showConfirmationModalGlobal(this.$t('component.modalConfirmation.contentDeleteFilter'))
            if (modalConfirmationResponse) {
                await store.removeCustomOption(option)
                this.showToastSuccessGlobal(this.$t('global.filterDeleted'))
            }
        },
        showRenameModal(option) {
            this.$refs.renameModal.show(option)
        },
        renameCustomOption(option) {
            store.renameCustomOption(option)
            this.showToastSuccessGlobal(this.$t('global.renamedFilter'))
        },
        async showUpdateModal(option) {
            const modalConfirmationResponse = await this.showConfirmationModalGlobal(this.$t('component.modalConfirmation.contentUpdateFilter'))
            if (modalConfirmationResponse) {
                this.$emit('update-option', option)
            }
        },
        async expand() {
            await store.expandSideBar()
            Vue.nextTick(() => { this.$emit('changed-width') })
        },
        async contract() {
            await store.contractSideBar()
            Vue.nextTick(() => { this.$emit('changed-width') })
        },
        setDefaultOption(ev) {
            store.setDefaultOption(ev)
            store.saveConfig()
        },
        setViewAll(ev) {
            store.setViewAll(ev)
            store.saveConfig()
            this.$emit('view-all-toggled', ev)
        },
        setResponsibilities(event) {
            store.setResponsibility(event)
            store.saveConfig()
            this.$emit('view-responsibility-changed', event)
        }
    }
}

</script>
